(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dokyu-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dokyu-banner-slider')) {
    customElements.define('dokyu-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.select(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.select(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.select(Number(dot.dataset.dot))));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide && this.contains(slide)) this.select(this.slides.indexOf(slide));
        });
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      select(nextIndex) {
        if (this.slides.length < 2) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-selected', String(index === this.index)));
      }
      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.select(this.index + 1), Number(this.dataset.interval) || 5000);
      }
      stop() { if (this.timer) clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function loadDokyuCardHoverImage(card) {
    const image = card?.querySelector('img[data-dokyu-hover-src]');
    if (!image) return;
    image.src = image.dataset.dokyuHoverSrc;
    image.srcset = image.dataset.dokyuHoverSrcset || '';
    image.removeAttribute('data-dokyu-hover-src');
    image.removeAttribute('data-dokyu-hover-srcset');
  }

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('.dokyu-product-card');
    if (card) loadDokyuCardHoverImage(card);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const card = event.target.closest('.dokyu-product-card');
    if (card) loadDokyuCardHoverImage(card);
  });

  } catch(e) { console.error(e); }
})();
})();
